import { defineProfile } from "./define.js";

export const ONLINE_STORE_PROFILE = defineProfile("online_store", {
  labels: [],
  home: ["unread_chats", "orders_today", "abandoned_carts", "payments_today", "ai_handoffs"],
  kpis: [
    "orders",
    "revenue",
    "conversion",
    "conversations",
    "ai_resolution",
    "payments_today",
    "ai_handoffs",
  ],
  panel: ["orders", "cart", "quotes", "account"],
  quickActions: ["send_product", "payment_link"],
  contactFields: [],
  aiTools: [
    "search_kb",
    "search_products",
    "send_product",
    "check_order_status",
    "create_order",
    "escalate",
  ],
  cloudStarterMenu: "shop_menu",
});
